import React, { useContext, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  CardBody,
  FormGroup,
  Label,
  Input,
  CardHeader,
  CardFooter,
  Button,
} from "reactstrap";
import { toast } from "react-toastify";
import validator from "validator";
import Axios from "axios";
import { UserContext } from "../../context/UserContext";
import { Redirect } from "react-router-dom";
const Test5 = () => {
  const context = useContext(UserContext);
  const [email, setEmail] = useState(context.user?.otpemail);
  const [firstname, setFirstName] = useState("");
  const [lastaname, setLastName] = useState("");
  const [password, setPassword] = useState("");
  // const [password,setPassword]=useState('')
  console.log(setEmail)
  const logindata = {
    email: "",
    firstname: "",
    lastaname: "",
    password: "",
  };
  if(context.user===null)
  {
    toast.error("Seems that you have refresh Page,try again", {
      position: toast.POSITION.BOTTOM_LEFT,
    });
  }
  const handleRegSubmit = (e) => {
    e.preventDefault();
    registeruser();
  };
  const registeruser = async () => {
    if (firstname === "" || lastaname === "" || password === "") {
      toast.error("Enter valid details", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    } else if (!validator.isAlpha(firstname)) {
      toast.error("Enter Valid FirstName", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    } else if (!validator.isAlpha(lastaname)) {
      toast.error("Enter Valid FirstName", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }
    else if(password.length<=7)
    {
      toast.error("Password length must be greater than or equals to 8", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }
    logindata.email = email;
    logindata.password = password;
    logindata.firstname = firstname;
    logindata.lastaname = lastaname;
    await Axios.post("Login/registerr", { logindata })
      .then((res) => {
        if (res.data.status === "200" && res.data.exist==="true") {
          toast.error("Already Register !!!", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
        }
        else if (res.data.status === "200" && res.data.exist==="false") {
          toast.success("Registration successful!!", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          context.setUser({email:res.data.email})
        }
        throw res;
      })
      .then((resJson) => {})
      .catch((error) => {
        console.log("error123", error);
      });
  };
  if(context.user?.email)
  {
	return<Redirect to="/"/>
  }
  else if(context.user===null)
  {
    return<Redirect to="/test3"/>
  }
  return (
    <div>
      <Container className="text-center">
        <Row>
          <Col lg={6} className="offset-lg-3 mt-5">
            <Card>
              <Form onSubmit={handleRegSubmit}>
                <CardHeader className="">Enter your Details</CardHeader>
                <CardBody>
                <FormGroup row>
                    <Label for="email" sm={3}>
                      username
                    </Label>
                    <Col sm={9}>
                      <Input
                        type="text"
                        name="emai"
                        id="emai"
                        value={email}
                        disabled={true}
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label for="firstname" sm={3}>
                      FirstName
                    </Label>
                    <Col sm={9}>
                      <Input
                        type="text"
                        name="firstname"
                        id="firstname"
                        placeholder="Enter your FirstName"
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label for="lastname" sm={3}>
                      LastName
                    </Label>
                    <Col sm={9}>
                      <Input
                        type="lastname"
                        name="lastname"
                        id="lastname"
                        placeholder="Enter your LastName"
                        onChange={(e) => setLastName(e.target.value)}
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label for="password" sm={3}>
                      Password
                    </Label>
                    <Col sm={8}>
                      <Input
                        type="password"
                        name="password"
                        id="password"
                        placeholder="your password here"
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </Col>
                  </FormGroup>
                </CardBody>
                <CardFooter>
                  {email ? <Button type="submit" block color="primary">
                    Verify OTP
                  </Button>:"Invalid Request"}
                </CardFooter>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Test5;
